import { createContext, ReactNode, useContext, useEffect, useMemo, useState } from 'react';
import { moduleAccessApi, ModuleAccessItem } from '../api/moduleAccess';

interface Value {
  isOwner: boolean;
  modules: ModuleAccessItem[];
  loading: boolean;
  enabled: (key: string) => boolean;
  refresh: () => Promise<void>;
}

const Context = createContext<Value | undefined>(undefined);

export function ModuleAccessProvider({ children }: { children: ReactNode }) {
  const [isOwner, setIsOwner] = useState(false);
  const [modules, setModules] = useState<ModuleAccessItem[]>([]);
  const [loading, setLoading] = useState(true);
  const refresh = async () => {
    try {
      const data = await moduleAccessApi.get();
      setIsOwner(data.is_owner); setModules(data.modules);
    } finally { setLoading(false); }
  };
  useEffect(() => { if (localStorage.getItem('saik_token')) void refresh(); else setLoading(false); }, []);
  const value = useMemo(() => ({ isOwner, modules, loading,
    enabled: (key: string) => key === 'automation' || (modules.find(item => item.key === key)?.enabled ?? false),
    refresh,
  }), [isOwner, modules, loading]);
  return <Context.Provider value={value}>{children}</Context.Provider>;
}

export function useModuleAccess() {
  const value = useContext(Context);
  if (!value) throw new Error('useModuleAccess must be used within ModuleAccessProvider');
  return value;
}
